<div class="col-md-12 col-lg-12">
  <span class="dashboardHeader">Incoming funds</span>
  <div class="value-align">
    <span class="text-label mb-0"></span>
    <div class="value-align">
      <span class="text-label mb-0">Total</span>
      <div class="text-value2 text-left">
        {{ TOTAL_FUNDS?.currency === "USD" ? "$" : TOTAL_FUNDS?.currency }}
        {{ TOTAL_FUNDS?.value | number : "1.2-2" }}
      </div>
    </div>
  </div>
</div>
